module.exports = __webpack_public_path__ + "static/media/anise.686ba5c5.png";